import { configureStore } from '@reduxjs/toolkit'
import { apiSlice } from './api/apiSlice'
import authReducer from './slices/authSlice'
// Đăng ký endpoints (injectEndpoints) – POC và triển khai thật dùng chung
import './api/casesApi'
import './api/filingsApi'
import './api/documentsApi'
import './api/courtSessionsApi'
import './api/alertsApi'
import './api/judgesApi'

export const store = configureStore({
  reducer: {
    [apiSlice.reducerPath]: apiSlice.reducer,
    auth: authReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(apiSlice.middleware),
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
